import { BASE_URL } from './Config.js';

export class DevisService {
  createDevis = async (devisData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/devis/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(devisData)
      });
      if (!response.ok) throw new Error('Erreur création devis');
      return await response.json();
    } catch (error) { console.error('Error creating devis:', error); throw error; }
  };

  getAllDevis = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/devis/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur chargement devis');
      return await response.json();
    } catch (error) { console.error('Error fetching devis:', error); throw error; }
  };

  getDevisById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/devis/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur chargement détail devis');
      return await response.json();
    } catch (error) { console.error('Error fetching devis:', error); throw error; }
  };

  updateDevis = async (id, devisData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/devis/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(devisData)
      });
      if (!response.ok) throw new Error('Erreur mise à jour devis');
      return await response.json();
    } catch (error) { console.error('Error updating devis:', error); throw error; }
  };

  deleteDevis = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/devis/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur suppression devis');
      return true;
    } catch (error) { console.error('Error deleting devis:', error); throw error; }
  };

  publishDevis = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/devis/publish/${id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur publication devis');
      return await response.json();
    } catch (error) { console.error('Error publishing devis:', error); throw error; }
  };
}